import api from '~services/axios';

export default {

  // 签到记录-列表
  apiGetSignInList: params => api.get('/api/signin/querylist', { params }),

  // 签到记录-详情
  apiGetSignInDetail: params => api.get('/api/signin/queryDetail', { params }),

  // 签到记录-导出
  apiHandleSignInExport: (params, config) => api.post('/api/signin/download', params, config),

  // 数据看板-销售人员业绩表格
  apiGetSalesmanTableData: params => api.get('/api/datakanban/queryUserAchievementList', { params }),

  // 数据看板-各产品线业绩表格
  apiGetBusiLineTableData: params => api.get('/api/datakanban/queryBusinessLineList', { params }),

  // 数据看板-客户分类业绩表格
  apiGetCustomClassifyTableData: params => api.get('/api/datakanban/queryCustomerTypeRPList', { params }),

  // 数据看板-部门各产品线业绩表格
  apiGetDepaBusiLineTableData: params => api.get('/api/datakanban/queryDepaProductList', { params }),

  // 数据看板-三级部门各产品线业绩表格
  apiGetThreeBusiLineTableData: params => api.get('/api/datakanban/queryFourLevelDepaList', { params }),

  // 数据看板-各部门业绩表格
  apiGetDepartmentTableData: params => api.get('/api/datakanban/queryDepaPerformanceList', { params }),

  // 数据看板-客户TOP榜
  apiGetCustomTopTableData: params => api.get('/api/datakanban/queryCustomerPaymentTopList', { params }),

  // 数据看板-三级部门业务统计表格
  apiGetDep3OfBusPerformanceTableData: params => api.get('/api/datakanban/queryFourDepaPerformanceList', { params }),

  // 数据看板-客户收入统计表格
  apiGetCustomerRevenueTableData: params => api.get('/api/datakanban/queryCustomerTypeRevenueList', { params }),

  //  打卡记录-获取列表数据
  apiGetTimingRecordList: params => api.get('/api/clockIn/query', { params }),

  // 打卡记录-获取团队
  apiGetTimingRecordTeams: params => api.get('/api/clockIn/queryclockInteam', { params }),

  // 打卡记录-详情
  apiGetTimingRecordDetail: params => api.get('/api/clockIn/detail', { params }),

  // 项目线上服务top
  apiGetProOnlineTopTableData: params => api.get('/api/serviceData/query/projectService/online', { params }),

  // 项目线下服务top
  apiGetProOfflineTopTableData: params => api.get('/api/serviceData/query/projectService/offline', { params }),

  // 电话咨询
  apiGetTelCounselingTableData: params => api.get('/api/serviceData/query/telephoneStatistics', { params }),

  // 线下服务
  apiGetOfflineServiceTableData: params => api.get('/api/serviceData/query/orderCost/offline', { params }),

  // 线下服务
  apiGetCustomSelectData: params => api.get('/api/serviceData/query/customer', { params }),

  // 医生电话联系
  apiGetDoctelConnectionList: params => api.get('/api/videocall/query', { params }),
  // 团队
  apigetStatiisticsTeamList: params => api.get('/api/datakanban/queryteam', { params }),
};
